/** DOM anchors return viewport pixels, so Pixi and pointer input use the same space. */
export function layoutStage(el: HTMLElement): void {
  const width = window.visualViewport?.width ?? window.innerWidth;
  const height = window.visualViewport?.height ?? window.innerHeight;
  // Phones turned sideways draw on their own layout: the scaled stage would shrink the page to a stamp.
  const shortCreator = el.classList.contains('scene-creator') && height <= 520;
  const fixed = width > 760 && width > height && !shortCreator;
  el.classList.toggle('fixed-stage', fixed);
  if (!fixed) return;
  const scale = Math.min(width / 1920, height / 1080);
  el.style.setProperty('--stage-scale', String(scale));
  el.style.setProperty('--stage-left', `${(width - 1920 * scale) / 2}px`);
  el.style.setProperty('--stage-top', `${(height - 1080 * scale) / 2}px`);
}
